const state = {
  trabajosLibres: []
}

const getters = {
  allTrabajosLibres (state) {
    return this.allTrabajosLibres
  }
}

const actions = {
  setTrabajosLibres (context, params) {
    context.commit('SETTRABAJOLIBRES', params)
  }
}

const mutations = {
  SETTRABAJOLIBRES (state, params) {
    state.trabajosLibres = params
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/trabajosLibres.js